import { notify } from './notifications';

export const handleRefresh = (message: string, msDelay = 2000) => {
	notify({
		type: 'info',
		message,
	});
	setTimeout(() => {
		window.location.reload();
	}, msDelay);
};

/**
 * Downloads a file from a presigned S3 URL by navigating the browser to it via a
 * synthetic anchor click. We deliberately do NOT `fetch()` the URL and build a
 * blob: a cross-origin JS fetch is subject to CORS (and the old `Cache-Control`
 * header forced a preflight), which S3 rejects unless the bucket has a CORS
 * config. A plain anchor navigation is not a CORS request, so it just works.
 *
 * Note: the `download` attribute is ignored for cross-origin URLs, so the
 * filename (and whether the browser saves vs. opens the file) is controlled by
 * the `response-content-disposition` baked into the presigned URL server-side.
 */
export const downloadFileFromS3 = (downloadUrl: string) => {
	const a = window.document.createElement('a');
	a.href = downloadUrl;
	a.rel = 'noopener';

	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};
